<template>
	<div class="deliver-manage-body">
		<div class="order-detail-header">
			<img src="~/images/icon/position.png" alt="" class="position">
			<div class="my-position">您的位置：</div>
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item>
					<span class="go-back-span" @click="goList('all')">全部订单</span>
				</el-breadcrumb-item>
				<el-breadcrumb-item>
					<span class="go-back-span" @click="goList('send')">{{orderstatus}}</span>
				</el-breadcrumb-item>
				<el-breadcrumb-item>
					<span class="go-back-span" @click="goDetail()">订单详情</span>
				</el-breadcrumb-item>
				<el-breadcrumb-item>发货管理</el-breadcrumb-item>
			</el-breadcrumb>
			<div class="header-btn">
				<el-button size="small" type="primary" plain class="btn fx-btn" style="margin-left: 0px" icon="el-icon-printer" @click="printerEvent">打印</el-button>
				<el-button size="small" type="primary" plain class="btn fx-btn export-btn" style="margin-left: 10px" @click="exportExcel">
					<div></div>
					导出
				</el-button>
			</div>
		</div>
		<div class="order-detail-info">
			<div class="search-box">
				<span class="search-title">商品名称:</span><el-input v-model="productName" placeholder="请输入商品名称" size="small" prefix-icon="el-icon-search" :maxlength="50"></el-input>
				<span class="search-title">发货状态:</span><el-select v-model="sendstatus" class="select-input" size='small'>
					<el-option :value="-1" label="全部"></el-option>
					<el-option :value="2" label="已发货"></el-option>
					<el-option :value="1" label="发货中"></el-option>
					<el-option :value="0" label="未发货"></el-option>
				</el-select>
				<el-button type="primary" size="small" @click="getDetail" style="margin-left: 15px;">查询</el-button>
			</div>
		</div>
		<div class="main-table">
			<div class="have-selected" v-show="ids.length !== 0">已选<span>{{ids.length}}</span>项</div>
			<div class="main-table-box">
				<el-table
					:stripe='true'
					size='mini'
					class="grid-content"
					:data="tableData"
					:height="tableHeight"
					ref="table"
					@selection-change="handleSelectionChange">
					<el-table-column
					type="selection"
					align="center"
					:selectable='selectable'
					width="55">
					</el-table-column>
					<el-table-column
						label="商品"
						width="500"
						align="center">
						<template slot-scope='scope'>
							<div class="shop-info">
								<img src="~/images/icon/new-add-icon.png" alt="" class="goods-flag-icon" v-if="scope.row.newflag">
								<img src="~/images/icon/presentation-icon.png" alt="" class="goods-flag-icon" v-if="scope.row.giftflag" :class="{'no-new': scope.row.newflag}">
								<w-image :src="scope.row.imgurl" alt="" type="product" width="90" height="90"></w-image>
								<div class="shop-detail">
									<div class="shop-name" :title="scope.row.pname">{{scope.row.pname}}</div>
									<div class="shop-spec" :title="'规格：' + scope.row.spec">规格：{{scope.row.spec}}</div>
								</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column
						prop="price"
						label="单价"
						align="center"
						min-width="100">
						<template slot-scope='scope'>
							<div>¥ {{scope.row.initialprice}}</div>
						</template>
					</el-table-column>
					<el-table-column
						prop="price"
						label="实际单价"
						align="center"
						min-width="100">
						<template slot-scope='scope'>
							<div>¥ {{scope.row.price}}</div>
						</template>
					</el-table-column>
					<el-table-column
						prop="realmoney"
						label="小计"
						align="center"
						min-width="100">
						<template slot-scope='scope'>
							<div>¥ {{scope.row.realmoney}}</div>
						</template>
					</el-table-column>
					<el-table-column
						prop="sendstatus"
						label="状态"
						align="center"
						min-width="100">
						<template slot-scope='scope'>
							<div style="font-weight:bold">
								<span v-if='scope.row.sendstatus === 0'>未发货</span>
								<span style="color: #FF7226" v-if='scope.row.sendstatus === 1'>发货中</span>
								<span style="color: #48B155" v-if='scope.row.sendstatus === 2'>已发货</span>
							</div>
						</template>
					</el-table-column>
					<el-table-column
						prop="itemquantity"
						label="订货量"
						align="center"
						min-width="200">
						<template slot-scope='scope'>
							<div>
								× {{scope.row.itemquantity}}
								<span v-if="scope.row.useUnitFlag === 1">{{scope.row.baseUnit}}</span>
							</div>
							<div v-if="scope.row.useUnitFlag === 1">
								× {{scope.row.assistQuantity}}
								<span>{{scope.row.assistUnit}}</span>
							</div>
						</template>
					</el-table-column>
					<el-table-column
						prop="sendedquantity"
						label="已发量"
						align="center"
						min-width="100">
						<template slot-scope='scope'>
							<div>× {{scope.row.sendedquantity}}</div>
						</template>
					</el-table-column>
					<el-table-column
						prop="diffcount"
						label="差发量"
						align="center"
						min-width="150">
						<template slot-scope='scope'>
							<div>
								<span v-if="scope.row.sendedquantity < scope.row.itemquantity">少发</span><span v-if="scope.row.sendedquantity > scope.row.itemquantity">多发</span> × {{scope.row.diffcount}}
							</div>
						</template>
					</el-table-column>
					<el-table-column label="发货量" min-width="260" align="center">
						<template slot-scope="scope">
							<el-input-number :ref="'number' + scope.$index" @keydown.up.native="keyUp(scope.$index, scope.row)" @keydown.down.native="keyDown(scope.$index, scope.row, 'down')" @keydown.enter.native="keyDown(scope.$index, scope.row, 'enter')" v-if="scope.row.checked"  v-model="scope.row.sendquantity" :precision="orderdecimalcount" size="small" :min="0" :class="scope.row.sendquantity > scope.row.itemquantity ? 'sendcolor' : ''"></el-input-number>
							<span v-if="scope.row.checked && scope.row.useUnitFlag === 1">{{scope.row.baseUnit}}</span>
							<!-- @change="(oldval, newval) => stepBlur(oldval, newval, scope.$index)" -->
							<!-- <el-input v-model="scope.row.sendquantity" type="number" size="mini" @input="handleInput(scope.row)" @change="handleInputChange(scope.row)"></el-input> -->
						</template>
					</el-table-column>
					<!-- <el-table-column label="操作" min-width="100" align="center">
						<template slot-scope="scope">
							<el-button @click="showDialog(scope.row)" v-if='scope.row.sendstatus !== 2' type='text' size="mini">发货</el-button>
							<el-button @click="goDeliverHistory(scope.row)" v-else type='text' size="mini">发货记录</el-button>
						</template>
					</el-table-column> -->
				</el-table>
			</div>
			<div class="info-btn">
				<el-button class="btn" size="small" plain type="primary" :disabled="isSend === 3" v-if="AuthorityList['07_0001_0009_00']" @click="addGoodsEvent">添加商品</el-button>
				<el-button class="btn" size="small" type="primary" plain v-if="AuthorityList['07_0001_0009_00']" @click="allShowDialog">确认发货</el-button>
				<el-button class="btn" size="small" type="primary" plain :disabled="isSend === 3" v-if="AuthorityList['07_0001_0009_00']" @click="deliverGoods">结束发货</el-button>
				<el-button class="btn" size="small" type="primary" plain @click="goDeliverHistory">历史发货记录</el-button>
			</div>
        </div>
		<el-dialog
			:title="usertype === 0 ? '填写发货信息' : '发货确认'"
			:visible.sync="dialogVisible"
			:close-on-click-modal="false"
			class="dialog-title"
			width="800px">
			<div class="dialog-body">
				<div class="filters-container">
					<div class="input-box">
						<span>发货方式：</span>
						<el-select v-model="usertype" disabled class="name-input" size='small' @change='handleChange'>
							<el-option :value="0" label="快递"></el-option>
							<el-option :value="1" label="自提"></el-option>
						</el-select>
					</div>
					<div class="input-box" v-if="usertype === 0">
						<span>快递公司：</span>
						<el-select v-model="companyName" class="name-input" size='small'>
							<el-option
								v-for="item in options"
								:key="item.value"
								:label="item.value"
								:value="item.id">
							</el-option>
						</el-select>
					</div>
					<div class="input-box" v-if="usertype === 0">
						<span>物流单号：</span>
						<el-input
							v-model="number"
							placeholder="请输入物流单号"
							class="name-input"
							size="mini"
							@input="changeNumber"
							onkeyup="value=value.replace(/[^a-zA-Z0-9]/ig,'')"
							></el-input>
					</div>
				</div>
				<div class="btn-box">
					<el-button class="btn" size="small" @click="close">取消</el-button>
					<el-button class="btn" size="small" type="primary" @click="save">确认发货</el-button>
				</div>
			</div>
		</el-dialog>
		<el-dialog
			title="打印设置"
			:visible.sync="printerVisible"
			class="dialog-title"
			width="530px">
				<Print :ids="[orderid]" :templateType="0" v-if="printerVisible"/>
		</el-dialog>
		<el-dialog
			title="添加商品"
			:visible.sync="addGoodsVisible"
			:close-on-click-modal="false"
			class="dialog-title"
			width="600px">
			<div class="add-goods-dialog">
				<div class="add-goods-content">
					<div class="add-goods-select-box">
						<span>请选择商品：</span>
						<el-select
							size="mini"
							filterable
							clearable
							v-model="addGoodsValue"
							placeholder="请选择商品"
							@change="addGoodsChange"
							@clear="addGoodsClear"
							@keyup.enter.native="enterEvent"
						>
							<el-option
								v-for="item in addGoodsList"
								:key="item.productid"
								:label="item.productName"
								:value="item.productid">
							</el-option>
						</el-select>
					</div>
					<div class="add-goods-info" v-if="goodsInfoShow">
						<div class="add-goods-item">
							<span>商品信息：</span>
							<div class="goods-info-box">
								<img v-if="addGoodsImg === ''" src="~/images/img/no-goods-img.png" alt="">
								<w-image v-else :src="addGoodsImg" alt=""></w-image>
								<div>
									<div>{{addGoodsName}}</div>
									<div v-if="spec_showInventoryFlag ===1 || matchbillcenterflag ===0">库存：{{inventory}}</div>
									<div v-if="minbuycnt !==0">最小起购量：{{minbuycnt}}</div>
								</div>
							</div>
						</div>
						<div class="add-goods-item">
							<span>规格：</span>
							<div class="select-box">
								<span v-show="!item.disableflag" :class="{ active: item.default }" v-for="item in unitArr" :key="item.spec" @click="unitChange(item)">{{item.spec}}</span>
							</div>
						</div>
						<div class="add-goods-item">
							<span>是否是赠送：</span>
							<div class="select-box1">
								<el-switch
									style="margin-right: 5px;"
									:disabled="giftdisableflag"
									v-model="giftflag"
									active-color="#13ce66">
								</el-switch>
								<span v-if="giftflag">赠送</span>
								<span v-else>不赠送</span>
							</div>
						</div>
						<div class="add-goods-item">
							<span>单价：</span>
							<div class="select-box1">
								<span>￥{{addPrice}}</span>
							</div>
						</div>
						<div class="add-goods-item">
							<span>数量：</span>
							<div  style="flex:1">
								<div style="display: flex;flex-direction: row;align-items: center;">
									<el-input size="mini" v-model="addGoodsNum" @input='checkNum' @blur="addGoodsNumBlur" @change="addGoodsNumChan"/>
									<div style="min-width: 250px;margin-left: 10px;" v-if='useUnitFlag === 1'>{{unit.assistUnitName}}（1{{unit.assistUnitName}}={{unit.assistRatio}} {{unit.baseUnitName}}）</div>
								</div>
								<span v-if="minbuycntFlag" class="minbuycnt-tips">最小订货数{{minbuycnt}}</span>
							</div>
						</div>
					</div>
				</div>
				<div class="btn-box">
					<el-button class="btn" size="small" type="primary" @click="confirmAdd">添加</el-button>
					<el-button class="btn" size="small" plain type="primary" @click="cancelAdd">取消</el-button>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import Print from '@/components/print/Print.vue'
export default {
	name: 'deliverManage',
	components: {
		Print
	},
	data () {
		return {
			useUnitFlag: 0,
			unit: null,
			notActivityFlag: false,
			shopName: '',
			billState: '',
			orderStatus: '',
			afterbillflag: false,
			detailData: '',
			dialogVisible: false,
			usertype: null,
			companyName: '',
			sendstatus: -1,
			options: [
				{ 'id': 'shunfeng', 'value': '顺丰' },
				{ 'id': 'yuantong', 'value': '圆通' },
				{ 'id': 'yunda', 'value': '韵达' },
				{ 'id': 'shentong', 'value': '申通' },
				{ 'id': 'huitongkuaidi', 'value': '百世' },
				{ 'id': 'zhongtong', 'value': '中通' },
				{ 'id': 'ems', 'value': 'EMS' },
				{ 'id': 'debangwuliu', 'value': '德邦' },
				{ 'id': 'debangkuaidi', 'value': '德邦快递' },
				{ 'id': 'youzhengbk', 'value': '邮政标准快递' },
				{ 'id': 'zhaijisong', 'value': '宅急送' },
				{ 'id': '0', 'value': '其他' }
			],
			cancelstate: false,
			arriveDate: '',
			arriveDateFlag: 0,
			freight: 0,
			sendCountFlag: 0,
			freightFlag: 0,
			priceFlag: 0,
			goodsItemParams: [],
			goodsSendParams: [],
			AuthorityList: {
				'07_0001_0001_00': false,
				'07_0001_0002_00': false,
				'07_0001_0003_00': false,
				'07_0001_0004_00': false,
				'07_0001_0005_00': false,
				'07_0001_0006_00': false,
				'07_0001_0007_00': false,
				'07_0001_0008_00': false,
				'07_0001_0009_00': false,
				'07_0001_0010_00': false,
				'07_0001_0011_00': false,
				'07_0001_0012_00': false,
				'07_0001_0013_00': false,
				'07_0001_0014_00': false,
				'07_0001_0015_00': false,
				'07_0001_0016_00': false,
				'07_0001_0017_00': false,
				'07_0001_0018_00': false,
				'07_0001_0019_00': false,
				'07_0001_0020_00': false,
				'07_0001_0021_00': false
			},
			backorderdock: 0,
			clddock: 0,
			pushstate: 0,
			tableData: [],
			selectTableData: [],
			tableHeight: '100%',
			ids: [],
			number: '',
			errorImgUrl: 'this.src="' + require('$assets/images/img/no-goods-img.png') + '"',
			isSend: 0,
			productName: '',
			orderid: '',
			orderdecimalcount: 0,
			printerVisible: false,
			canundeliveredoversendflag: false,
			orderstatus: '待发货',
			addGoodsVisible: false,
			addGoodsValue: '',
			addGoodsList: [],
			goodsInfoShow: false,
			addGoodsImg: '',
			addGoodsName: '',
			spec_showInventoryFlag: null,
			matchbillcenterflag: 0,
			inventory: 0,
			minbuycnt: 0,
			unitArr: [],
			giftdisableflag: false,
			giftflag: 1,
			addPrice: 0,
			addGoodsNum: 1,
			minbuycntFlag: false,
			attrplanid: '',
			storeid: '',
			storename: '',
			matchid: '',
			unitName: '',
			userinventoryflag: 0,
			selfPickAddress: '',
			selfPickTel: '',
			selfPickLinkName: ''
		}
	},
	created () {
		this.$fxEventBus.$emit('setMenu', '6-1')
		let orderParams = JSON.parse(window.sessionStorage.getItem('orderInfo'))
		this.orderid = orderParams.orderId
		this.getSyestem()
		this.getDetail()
		this.getAuthority('07_0001_0000_00')
		switch (this.orderstatus) {
		case '待付款':
			this.billState = '0'
			break
		case '待接单':
			this.billState = '1'
			break
		case '待发货':
			this.billState = '2'
			break
		case '备货中':
			this.billState = '2'
			break
		case '待收货':
			this.billState = '3'
			break
		case '已完成':
			this.billState = '4'
			break
		case '已取消':
			this.billState = '5'
			break
		}
		console.log(this.billState)
	},
	methods: {
		// stepBlur (value, oldvalue, item) {
		// 	console.log(value, oldvalue, item)
		// 	if (value === undefined) {
		// 		// item.sendquantity = oldvalue
		// 		this.selectTableData[item].sendquantity = oldvalue
		// 	}
		// },
		keyUp (index, row) {
			if (index !== 0) {
				row.sendquantity -= 1
				for (let i = index - 1; i < this.tableData.length; i--) {
					if (this.tableData[i].checked) {
						let ref = 'number' + i
						this.$refs[ref].focus()
						break
					}
				}
			} else {
				row.sendquantity -= 1
			}
		},
		keyDown (index, row, name) {
			// event.preventDefault()
			if (index !== this.tableData.length - 1) {
				if (name === 'down') {
					row.sendquantity += 1
				}
				for (let i = index + 1; i < this.tableData.length; i++) {
					if (this.tableData[i].checked) {
						let ref = 'number' + i
						console.log(this.$refs)
						this.$refs[ref].focus()
						break
					}
				}
			} else {
				if (name === 'down') {
					row.sendquantity += 1
				}
			}
		},
		printerEvent () {
			this.printerVisible = true
		},
		// 导出
		exportExcel () {
			const req = new XMLHttpRequest()
			let _this = this
			req.open('POST', `${this.$fxBaseApi.newExportUrl}/orderDetail/exportExcel`, true)
			req.responseType = 'blob'
			req.setRequestHeader('Content-Type', 'application/json')
			req.setRequestHeader('pname', 'bc2ff5388144d30e137b28acafd39795')
			req.setRequestHeader('shiroSession', window.sessionStorage.getItem('shiroSession'))
			req.onload = function () {
				const data = req.response
				const blob = new Blob([data])
				const blobUrl = window.URL.createObjectURL(blob)
				_this.download(blobUrl)
			}
			let orderParams = JSON.parse(window.sessionStorage.getItem('orderInfo'))
			let data = {
				orderid: orderParams.orderId,
				orderstatusname: orderParams.statusId
			}
			req.send(JSON.stringify(data))
		},
		download (blobUrl, num) {
			const a = document.createElement('a')
			a.style.display = 'none'
			var date = new Date()
			var year = date.getFullYear()
			var month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)
			var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
			var hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
			var min = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
			let name = '待发货 - 单据详情(' + year + month + day + hour + min + ').xls'
			a.download = name
			a.href = blobUrl
			a.click()
		},
		goList (name) {
			let tabParams = JSON.parse(window.sessionStorage.getItem('tabInfo'))
			tabParams.isSellerpull = false
			tabParams.active = this.orderStatus
			if (name === 'all') {
				tabParams.orderStatus = 8
				tabParams.active = '全部订单'
			} else {
				tabParams.orderStatus = 2
			}
			window.sessionStorage.setItem('tabInfo', JSON.stringify(tabParams))
			this.$router.push('/main/order')
		},
		goDetail () {
			this.$router.push('/main/orderDetail')
		},
		// 系统设置
		getSyestem () {
			let orderParams = JSON.parse(window.sessionStorage.getItem('orderInfo'))
			let params = {
				orderid: orderParams.orderId
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order/getOrderSystemSetting/`,
				data: params
			}).then(res => {
				if (res.result) {
					this.orderdecimalcount = res.data.orderdecimalcount
					this.canundeliveredoversendflag = res.data.canundeliveredoversendflag
					this.userinventoryflag = res.data.userinventoryflag
				} else {
					this.$message.error(res.msg)
				}
			}).catch((res) => {
				this.$message.error(res.msg)
			})
		},
		changeNumber (val) {
			if (val.length > 32) {
				this.number = this.number.substring(0, 32)
			}
		},
		save () {
			let arr = []
			for (let i = 0; i < this.tableData.length; i++) {
				if (this.tableData[i].checked) {
					if (+this.tableData[i].sendquantity === 0) {
						if (this.tableData[i].itemquantity === this.tableData[i].sendedquantity) {
							this.$message.error('【' + this.tableData[i].pname + '】已发货完成')
						} else {
							this.$message.error('【' + this.tableData[i].pname + '】的发货数量不能为0')
						}
						return false
					}
					if (this.tableData[i].sendquantity === '' || this.tableData[i].sendquantity === undefined) {
						this.$message.error('【' + this.tableData[i].pname + '】发货数不能为空')
						return false
					}
					if (+this.tableData[i].sendquantity > 999999) {
						this.$message.error('【' + this.tableData[i].pname + '】发货数不能超过999999')
						return false
					}
					if (!this.canundeliveredoversendflag) {
						if (+this.tableData[i].sendquantity > +this.tableData[i].diffcount) {
							this.$message.error('发货数不能超过订货数！')
							return false
						}
					}
					arr.push(this.tableData[i])
				}
			}
			let relCompanyName = ''
			this.options.forEach(item => {
				if (item.id === this.companyName) {
					relCompanyName = item.value
				}
			})
			let orderParams = JSON.parse(window.sessionStorage.getItem('orderInfo'))
			let params = {
				orderId: orderParams.orderId,
				sendtype: this.usertype,
				number: this.number,
				company: this.companyName,
				companyname: relCompanyName,
				obiDTOs: arr,
				selfPickAddress: this.selfPickAddress,
				selfPickTel: this.selfPickTel,
				selfPickLinkName: this.selfPickLinkName
			}
			// console.log(params, 'ppp')
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order/saveSendInfoToChlidOder/`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('保存成功!')
					if (res.data.data === 3) {
						this.orderstatus = '待收货'
					}
				} else {
					this.$message.error(res.msg)
				}
				this.dialogVisible = false
				this.getDetail()
			}).catch((res) => {
				this.$message.error(res.msg)
			})
		},
		goDeliverHistory (item) {
			if (item.oiid) {
				window.sessionStorage.setItem('historyoiid', item.oiid)
			} else {
				window.sessionStorage.setItem('historyoiid', 0)
			}
			this.$router.push('/main/deliverHistory')
		},
		deliverGoods () {
			let goodsname = ''
			this.tableData.forEach(e => {
				if (e.sendedquantity === 0) {
					goodsname += '【' + e.pname + '】'
				}
			})
			if (goodsname) {
				this.$confirm(goodsname + '的发货数量为0，是否要发货', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					closeOnClickModal: false
				}).then(() => {
					this.deliverHandle()
				}).catch(() => {
				})
			} else {
				this.deliverHandle()
			}
		},
		deliverHandle () {
			let orderParams = JSON.parse(window.sessionStorage.getItem('orderInfo'))
			let params = {
				orderId: orderParams.orderId
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order/sendGoodsEnd/`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('发货成功')
					this.orderstatus = '待收货'
					this.isSend = 3
					this.getDetail()
				} else {
					this.$message.error(res.msg)
				}
			}).catch((res) => {
				this.$message.error(res.msg)
			})
		},
		handleInput (item) {
			if (item.sendquantity < 0) {
				item.sendquantity = 0
			}
			if (item.sendquantity > item.itemquantity - item.sendedquantity) {
				item.sendquantity = item.itemquantity - item.sendedquantity
			}
		},
		handleInputChange (item) {
			if (item.sendquantity === '') {
				item.sendquantity = item.itemquantity - item.sendedquantity
			}
		},
		handleChange (item) {
			if (item === 1) {
				this.companyName = ''
				this.number = ''
			}
		},
		close () {
			this.dialogVisible = false
		},
		allShowDialog () {
			if (this.ids.length === 0) {
				this.$message.error('请勾选商品')
				return false
			}
			this.companyName = ''
			this.number = ''
			this.selectTableData = this.ids
			this.dialogVisible = true
		},
		selectable (row, index) {
			if (row.sendstatus === 2) {
				return false
			} else {
				return true
			}
		},
		handleSelectionChange (val) {
			let a = val
			this.ids = []
			let oipidArr = []
			for (let i = 0; i < a.length; i++) {
				this.ids.push(a[i])
				oipidArr.push(a[i].oipid)
			}
			console.log(val)
			this.tableData.forEach(e => {
				if (oipidArr.indexOf(e.oipid) !== -1) {
					e.checked = true
				} else {
					e.checked = false
				}
			})
		},
		getAuthority (data) {
			let params = {
				pId: data
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		},
		getDetail () {
			let orderParams = JSON.parse(window.sessionStorage.getItem('orderInfo'))
			let params = {
				orderId: orderParams.orderId,
				pname: this.productName,
				sendStatus: this.sendstatus
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order/getGoodsDetailInfoByOrderId/`,
				data: params
			}).then(res => {
				if (res.result) {
					res.data.forEach(item => {
						item.checked = false
						item.sendquantity = item.itemquantity - item.sendedquantity
						item.price = this.$fxUtils.toFixedSHW(item.price, 2)
						item.realmoney = this.$fxUtils.toFixedSHW(item.realmoney, 2)
						item.initialprice = this.$fxUtils.toFixedSHW(item.initialprice, 2)
					})
					this.tableData = res.data
					this.isSend = this.tableData[0].orderstatus
					this.usertype = this.tableData[0].selfpickflag
					this.$refs.table.doLayout()
				} else {
					this.$message.error(res.msg)
				}
			}).catch((res) => {
				this.$message.error(res.msg)
			})
		},
		// 是否开启小类
		checkSmallCategory () {
			// return new Promise((resolve, reject) => {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/checkSmallCategoryIsUser`
			}).then(res => {
				this.matchbillcenterflag = res.matchbillcenterflag
			})
			// })
		},
		checkNum () {
			this.addGoodsNum = this.addGoodsNum.replace(/[^\d.]/g, '')// 清除"数字"和"."以外的字符
			this.addGoodsNum = this.addGoodsNum.replace(/^\./g, '')// 验证第一个字符是数字而不是
			this.addGoodsNum = this.addGoodsNum.replace(/\.{2,}/g, '.')// 只保留第一个. 清除多余的
			this.addGoodsNum = this.addGoodsNum.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
			switch (this.orderdecimalcount) {
			case 0:
				this.addGoodsNum = this.addGoodsNum.replace(/[^0-9]/g, '')// 只能输入数字
				break
			case 1:
				this.addGoodsNum = this.addGoodsNum.replace(/^(\-)*(\d+)\.(\d).*$/, '$1$2.$3')// 只能输入一个小数
				break
			case 2:
				this.addGoodsNum = this.addGoodsNum.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')// 只能输入一个小数
				break
			case 3:
				this.addGoodsNum = this.addGoodsNum.replace(/^(\-)*(\d+)\.(\d\d\d).*$/, '$1$2.$3')// 只能输入一个小数
				break
			case 4:
				this.addGoodsNum = this.addGoodsNum.replace(/^(\-)*(\d+)\.(\d\d\d\d).*$/, '$1$2.$3')// 只能输入一个小数
				break
			}
		},
		cancelAdd () {
			this.addGoodsVisible = false
		},
		confirmAdd () {
			this.addGoods()
		},
		addGoods () {
			if (!this.goodsInfoShow) {
				this.$message.error('请选择商品后再添加！')
				return false
			}
			if ((+this.addGoodsNum) === 0) {
				this.$message.error('【' + this.addGoodsName + '】订货数量不能为0！')
				return false
			}
			if (this.inventory < 1 && this.userinventoryflag === 1) {
				this.$message.error('库存不足，无法添加')
				return false
			}
			let curGoodsInfo = {
				useUnitFlag: this.useUnitFlag,
				assistRatio: this.unit.assistRatio,
				assistUnitId: this.unit.assistUnitId,
				assistUnitName: this.unit.assistUnitName,
				baseUnitId: this.unit.baseUnitId,
				baseUnitName: this.unit.baseUnitName,
				productid: this.addGoodsValue,
				attrplanid: this.attrplanid,
				itemquantity: this.addGoodsNum,
				giftflag: this.giftflag ? 1 : 0,
				storeid: this.storeid,
				storename: this.storename,
				matchid: this.matchid,
				url: this.addGoodsImg,
				price: !this.giftflag ? this.addPrice : 0
			}
			console.log(this.billState)
			let params = {
				buyerSellerType: 1,
				orderstatus: this.billState,
				action: 4,
				orderid: this.orderid,
				statusid: JSON.parse(window.sessionStorage.getItem('orderInfo')).statusId,
				newProducts: [curGoodsInfo]
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order/update`,
				data: params
			}).then(res => {
				if (res.result) {
					let orderParams = JSON.parse(window.sessionStorage.getItem('orderInfo'))
					let tabParams = JSON.parse(window.sessionStorage.getItem('tabInfo'))
					this.getDetail(orderParams, tabParams)
					this.$message.success('添加成功！')
					this.addGoodsVisible = false
				}
			})
		},
		unitChange (item) {
			this.unitArr.forEach(i => {
				i.default = false
				if (item.spec === i.spec) {
					i.default = true
					this.attrplanid = item.attrplanid
					this.spec = item.spec
					this.spec_showInventoryFlag = item.spec_showInventoryFlag
					this.minbuycnt = item.minbuycnt
					this.addGoodsImg = item.url
					this.spec = item.spec
					this.price = item.private_price
					this.initialprice = item.private_price
					let baseprice = item.private_price ? item.private_price : item.public_price
					this.addPrice = this.useUnitFlag === 1 ? this.toFix(baseprice * item.unit.assistRatio) : baseprice
					this.addGoodsNum = this.minbuycnt
					this.giftflag = item.giftflag
					this.giftdisableflag = item.giftdisableflag

					this.useUnitFlag = item.useUnitFlag
					if (this.useUnitFlag === 1) {
						this.unit = item.unit
						this.inventory = this.toFix(item.inventory / item.unit.assistRatio)
					} else {
						this.inventory = item.inventory
						this.unit = {
							assistRatio: '',
							assistUnitId: '',
							assistUnitName: '',
							baseUnitId: '',
							baseUnitName: ''
						}
					}
				}
			})
		},
		enterEvent (e) {
			this.productName = e.target.value
			this.addGoodsEvent()
		},
		addGoodsChange () {
			let params = {
				id: this.addGoodsValue,
				orderid: this.orderid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getProductDetail`,
				data: params
			}).then(res => {
				if (res.result) {
					this.addGoodsName = res.data.product.productName
					this.weight = res.data.product.weight
					let flag = true
					res.data.unit_spec.forEach((item, index) => {
						if (index === 0) {
							if (item.disableflag) {
								item.default = false
							} else {
								flag = false
								item.default = true
								this.useUnitFlag = item.useUnitFlag
								if (this.useUnitFlag === 1) {
									this.unit = item.unit
									this.inventory = this.toFix(item.inventory / item.unit.assistRatio)
								} else {
									this.inventory = item.inventory
									this.unit = {
										assistRatio: '',
										assistUnitId: '',
										assistUnitName: '',
										baseUnitId: '',
										baseUnitName: ''
									}
								}
								this.giftflag = item.giftflag
								this.giftdisableflag = item.giftdisableflag
								this.spec_showInventoryFlag = item.spec_showInventoryFlag
								this.spec = item.spec
								this.addGoodsImg = item.url
								this.price = item.private_price
								this.spec = item.spec
								this.initialprice = item.private_price
								let baseprice = item.private_price ? item.private_price : item.public_price
								this.addPrice = this.useUnitFlag === 1 ? this.toFix(baseprice * item.unit.assistRatio) : baseprice
								this.minbuycnt = item.minbuycnt
								this.addGoodsNum = this.minbuycnt > 0 ? this.minbuycnt : 1
								this.attrplanid = item.attrplanid
							}
						} else {
							if (flag && !item.disableflag) {
								flag = false
								item.default = true
								this.useUnitFlag = item.useUnitFlag
								if (this.useUnitFlag === 1) {
									this.unit = item.unit
									this.inventory = this.toFix(item.inventory / item.unit.assistRatio)
								} else {
									this.inventory = item.inventory

									this.unit = {
										assistRatio: '',
										assistUnitId: '',
										assistUnitName: '',
										baseUnitId: '',
										baseUnitName: ''
									}
								}
								this.giftflag = item.giftflag
								this.giftdisableflag = item.giftdisableflag
								this.spec_showInventoryFlag = item.spec_showInventoryFlag
								this.spec = item.spec
								this.addGoodsImg = item.url
								this.price = item.private_price
								this.spec = item.spec
								this.initialprice = item.private_price
								// this.minbuycnt = item.minbuycnt > 0 ? item.minbuycnt : 1
								let baseprice = item.private_price ? item.private_price : item.public_price
								this.addPrice = this.useUnitFlag === 1 ? this.toFix(baseprice * item.unit.assistRatio) : baseprice
								this.minbuycnt = item.minbuycnt
								this.addGoodsNum = this.minbuycnt > 0 ? this.minbuycnt : 1
								this.attrplanid = item.attrplanid
							} else {
								item.default = false
							}
						}
					})
					this.unitArr = JSON.parse(JSON.stringify(res.data.unit_spec))
					res.data.store.forEach((item, index) => {
						item.default = false
						if (index === 0) {
							item.default = true
							this.storeid = item.storeid
							this.storename = item.storename
							this.matchid = item.matchid
						}
					})
					this.storeArr = res.data.store
					this.goodsInfoShow = true
				}
			})
		},
		toFix (price) {
			if (+price === 0) {
				return '0.00'
			}
			let num = isNaN(price) ? 0 : price
			num = +num + 0.0000000001
			num = num + ''
			num = num.substring(0, num.indexOf('.') + 3)
			return num
		},
		addGoodsClear () {
			this.productName = ''
			this.addGoodsEvent()
		},
		addGoodsEvent () {
			this.goodsInfoShow = false
			this.addGoodsList = []
			this.addGoodsValue = ''
			if (!this.addGoodsVisible) {
				this.productName = ''
			}
			this.minbuycntFlag = false
			let params = {
				shopid: this.shopid,
				orderid: this.orderid,
				productName: this.productName
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/goods/getProductList`,
				data: params
			}).then(res => {
				if (res.result) {
					this.addGoodsList = res.data
					this.addGoodsVisible = true
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		addGoodsNumBlur () {
			if (!this.addGoodsNum) {
				if (this.minbuycnt > 0) {
					this.minbuycntFlag = true
				}
				this.addGoodsNum = 1
			}
			if (this.minbuycnt > 0 && this.addGoodsNum < this.minbuycnt) {
				this.minbuycntFlag = true
			} else {
				this.minbuycntFlag = false
			}
		},
		addGoodsNumChan (value) {
			if (this.minbuycnt > 0 && value < this.minbuycnt) {
				this.minbuycntFlag = true
			} else {
				this.minbuycntFlag = false
			}
		}
	}
}
</script>

<style lang="stylus" scoped>
.deliver-manage-body{
	flex: 1
	display flex
	flex-direction column
	.shop-position {
		display flex
		align-items: center
		height: 50px
		font-size: 14px
		border-bottom: 1px solid #dce1fe
		img {
			display inline-block
			width: 20px
			height: 22px
			margin-right: 10px
		}
	}
	.shop-info{
		display: flex
		img {
			flex-shrink: 0
		}
		.goods-flag-icon {
			width: 24px;
			height: 24px;
			position: absolute;
			&.no-new {
				left: 40px;
			}
		}
		.shop-detail {
			margin-left :15px;
			display: flex
			flex-direction: column
			justify-content: space-between
			.shop-name {
				display: -webkit-box;
				-webkit-box-orient: vertical;
				-webkit-line-clamp: 2;
				overflow: hidden;
				text-align: left;
				white-space: pre-wrap;
				color: #333;
			}
			.shop-spec {
				color: #999
				display: -webkit-box;
				-webkit-box-orient: vertical;
				-webkit-line-clamp: 1;
				overflow: hidden;
				text-align: left;
			}
		}
	}
	.order-detail-header {
		height:50px;
		line-height:50px;
		text-align:left
		font-size: 16px;
		overflow: hidden
		// border-bottom 1px solid #DCE1FE
		.my-position {
			font-size: 14px;
			display: inline-block;
			position: relative;
			top: -20px;
		}
		.position {
			width: 15px;
			height: 15px;
			float: left;
			margin: 17px 11px 0 9px;
		}
		.el-breadcrumb {
			display inline-block
			height: 49px
			line-height: 49px
			.go-back-span {
				font-weight: 700
				cursor: pointer
			}
		}
		.header-btn {
			float: right
			display: flex;
			height: 100%;
			align-items: center;
		}
	}
	.order-detail-info {
		display: flex;
		justify-content: space-between
		align-items: center;
		margin-bottom: 15px;
		.search-box {
			display: flex
			align-items: center;
			.search-title {
				margin-right:10px;
				font-size:14px
			}
			.el-input {
				width: 260px;
				height: 32px;
				padding-right: 14px;
				.el-input__inner {
					height: 32px;
					line-height: 32px;
				}
			}
			// padding: 10px 0 14px 0
		}
	}
	.add-goods-content {
		min-height: 200px;
		padding-bottom: 20px;
		.add-goods-select-box {
			display: flex;
			span {
				padding-right: 8px;
				line-height: 28px;
			}
			.el-select {
				flex: 1;
			}
		}
		.add-goods-item {
			display: flex;
			margin: 10px 0;
			& > span {
				width: 84px;
				padding-right: 8px;
				line-height: 28px;
				text-align: right;
			}
			.minbuycnt-tips {
				margin-left: 8px;
				color: red;
			}
			.goods-info-box {
				flex: 1;
				display: flex;
				padding: 8px 12px;
				background: #FBFBFF;
				border-radius: 4px;
				border: 1px solid #F4F4F5;
				img {
					width: 100px;
					height: 100px;
					border-radius: 12px;
					border: 1px solid #eee;
				}
				& > div {
					padding-left: 6px;
					display: flex;
					flex-direction: column;
					justify-content: space-between;
					div {
						padding: 8px 0;
					}
				}
			}
			.select-box1 {
				flex: 1;
				min-width: 0;
				align-items :center;
				display :flex;
			}
			.select-box {
				flex: 1;
				min-width: 0;
				span {
					display: inline-block;
					min-width: 70px;
					height: 28px;
					line-height: 26px;
					border-radius: 6px;
					border: 1px solid #d1d5e4;
					color: #999c9a;
					text-align: center;
					margin-right: 12px;
					cursor: pointer;
					box-sizing: border-box;
					padding: 0 4px;
					margin-bottom: 6px;
					&.active {
						background: #F6F8FE;
						color: #62ADFA;
						border-color: #77b9fb;
					}
				}
			}
		}
	}
}
</style>
<style lang="stylus">
.deliver-manage-body {
	.main-table {
		display flex
		flex: 1
		flex-direction: column
		position: relative
		// height: 100%
		.have-selected {
			position: absolute;
			top: 7px;
			left: 50px;
			z-index: 9;
			font-size: 14px;
			color: #333;
			span {
				color: var(--fx-primary-color);
				margin: 0 3px;
			}
		}
		.main-table-box {
			flex: 1
			// height:calc(100% - 50px);
			padding-bottom 10px;
			overflow-y: auto;
		}
		.el-table {
			font-size: 14px
			th {
				background-color: #F7F8FA;
				font-weight: bold
			}
		}
		.info-btn {
			padding-bottom: 20px
			text-align left
			.btn {
				width :120px;
				height :35px;
				margin-right :20px;
			}
		}
	}
	.export-btn {
		span {
			display: flex;
			align-items: center
			div {
				width: 14px;
				height: 14px;
				margin-right: 5px;
				background-image: url('~images/icon/export-icon.png')
			}
		}
		&:hover {
			div {
				background-image: url('~images/icon/export-white-icon.png')
			}
		}
	}
	.sendcolor {
		.el-input__inner {
			color: #EC4141
		}
	}
	.el-input-number__decrease, .el-input-number__increase {
		background: #fff;
	}
	.el-dialog {
		border-radius: 4px
	}
	.el-dialog__title {
		padding-left 10px
		border-left 5px solid var(--fx-primary-color)
	}
	.el-dialog__body {
		padding-top: 10px
	}
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
	.el-radio-group {
		display flex
		flex-direction: column
		padding: 0 15px 20px
		.el-radio {
			line-height: 30px
		}
	}
	.btn-box {
		display flex
		justify-content: flex-end
		margin-top: 15px
		// .el-button {
		// 	width: 120px
		// }
	}
	.filters-container {
		display flex
		flex: 1
		align-items: center
		height: 110px
		flex-wrap: wrap
		// margin-top: 15px
		.input-box {
			display flex
			width: 350px
			margin-right: 10px
			span {
				// margin-right: 5px
				line-height: 28px
			}
			.name-input {
				flex: 1
			}
		}
		.btn {
			height: 32px
			margin-top: 14px
			margin-left 20px
		}
	}
}
</style>
